import React, { useContext } from 'react';
import { Row, Col } from "react-bootstrap";
import img from '../../../assets/Img';
import { useTranslation } from 'react-i18next'; 

const translations = {
  en: require('../../../Translate/en.json').ContentMarketing.SocialMediaSection3,
  ar: require('../../../Translate/ar.json').ContentMarketing.SocialMediaSection3,
};

const SocialMediaSection3 = () => {
  const { i18n } = useTranslation();
    const isLang = i18n.language;
  const t = translations[isLang || 'en'];

  return (
    <div className="social-media-section social-media-section2 d-flex flex-column pb-5">
      <div className="d-flex justify-content-center align-items-center bg w-100">
        <img
          width={1000}
          height={300}
          src={img.ContentMarketingBg}
          alt="Copywriting illustration"
          className="h-auto"
        />
      </div>

      <Row   justify="center" className="mt" style={{ marginTop: '-350px' }}>
        {["LeadGeneration", "CROServices", "LinkBuilding"].map((serviceKey, index) => (
          <Col xl={4} lg={4} md={12} sm={12} xs={12} key={index}>
            <div className="card">
              <h3>{t[serviceKey].title}</h3>
              <p>{t[serviceKey].description}</p>
              <ul>
                {[1, 2, 3].map((n) =>
                  t[serviceKey][`title${n}`] ? (
                    <li key={n}>
                      <b>{t[serviceKey][`title${n}`]}:</b> {t[serviceKey][`description${n}`]}
                    </li>
                  ) : null
                )}
              </ul>
            </div>
          </Col>
        ))}
      </Row>
    </div>
  );
};

export default SocialMediaSection3;
